/**
 * Status Badge Color Mappings
 * Centralized color definitions for StatusBadge component
 *
 * Colors are Mantine color names (not hex values)
 * to ensure theme compatibility and dark mode support.
 */

import { NoteVisibility } from '@/types/notes';

// Task Status Colors (Mantine color names)
// UWAGA: Kolory statusów są identyczne w light i dark mode
export const TASK_STATUS_BADGE_COLORS: Record<string, string> = {
  Pending: 'gray',
  InProgress: 'blue',
  Delayed: 'yellow',
  Completed: 'green',
  Archived: 'gray',
} as const;

// Priority Colors (Mantine color names)
export const PRIORITY_BADGE_COLORS: Record<string, string> = {
  Low: 'gray',
  Medium: 'yellow',
  High: 'orange',
  Urgent: 'red',
} as const;

// Role Colors (Mantine color names) - align with existing WORKSPACE_ROLE_COLORS
export const ROLE_BADGE_COLORS: Record<string, string> = {
  Owner: 'orange',
  Admin: 'red',
  Editor: 'blue',
  Viewer: 'gray',
} as const;

// Invitation Status Colors (Mantine color names) - align with existing INVITATION_STATUS_COLORS
export const INVITATION_STATUS_BADGE_COLORS: Record<string, string> = {
  Pending: 'yellow',
  Accepted: 'green',
  Expired: 'gray',
  Revoked: 'red',
} as const;

// Note Visibility Colors (Mantine color names)
export const NOTE_VISIBILITY_BADGE_COLORS: Record<NoteVisibility, string> = {
  [NoteVisibility.Private]: 'gray',
  [NoteVisibility.Workspace]: 'indigo',
} as const;

/**
 * Combined color mappings for StatusBadge component
 */
export const STATUS_BADGE_COLORS = {
  taskStatus: TASK_STATUS_BADGE_COLORS,
  priority: PRIORITY_BADGE_COLORS,
  role: ROLE_BADGE_COLORS,
  invitationStatus: INVITATION_STATUS_BADGE_COLORS,
} as const;

/**
 * i18n key prefixes for each badge type
 */
export const STATUS_BADGE_I18N_PREFIXES = {
  taskStatus: 'taskStatus',
  priority: 'priority',
  role: 'workspace.roles',
  invitationStatus: 'workspace.invitationStatus',
} as const;
